module.exports = __webpack_public_path__ + "img/big-city.7162c084.png";